/**
 * APP-LOCAL custom Phoenix icon registry (AB#2032 — INTERIM).
 *
 * `continity-shared-ui`'s `app-icon` set does not (yet) carry every glyph the Phoenix portal wants (e.g. the
 * onboarding `rocket`). Rather than a shared-ui round-trip for each new glyph, custom SVGs live here and are
 * rendered by {@link PhoenixIconComponent} (which otherwise delegates to `app-icon`). Add a new Phoenix-only
 * icon by dropping its inline SVG here under a stable name.
 *
 * 🚧 INTERIM: these custom icons should later be promoted INTO `continity-shared-ui` so the whole platform
 * shares one icon set — tracked as Follow-up AB#2032. Until then, extend this map.
 *
 * SVG conventions (so a glyph fills the wrapper + inherits colour): `width="100%" height="100%"`,
 * `stroke="currentColor"`, `fill="none"` (lucide default), `aria-hidden="true"` (the label rides the host).
 */
export const PHOENIX_CUSTOM_ICONS: Record<string, string> = {
  // lucide "rocket" (https://lucide.dev/icons/rocket) — the onboarding glyph.
  rocket: `<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/><path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/></svg>`,
};
